export default {
    setInvoicesPerPage(state, perPage) {
        state.invoicesPerPage = perPage;
    },
    setPaidInvoicesPerPage(state, perPage) {
        state.paidInvoicesPerPage = perPage;
    },
};
